const geofenceInitialState = {
  geofences: [],
  activeGeofence: null,
  isSaving: false,
  saveError: null,
  saveSuccess: null,
  isSideBarOpen: true,
  isFetching: false,
  selectedGeofenceId: null,
  editingGeofence: null,
};

const geofenceReducer = (state = geofenceInitialState, action) => {
  switch (action.type) {
    case "GET_ALL_GEOFENCES_START":
      return {
        ...state,
        isFetching: true,
      };
    case "GET_ALL_GEOFENCES_SUCCESS":
      return {
        ...state,
        isFetching: false,
        geofences: action.payload,
      };
    case "GET_ALL_DEVICES_FAILURE":
      return {
        ...state,
        isFetching: false,
        saveError: action.payload,
      };
    case "SET_ACTIVE_GEOFENCE":
      return { ...state, activeGeofence: action.payload };

    case "SAVE_GEOFENCE_START":
      return { ...state, isSaving: true, saveError: null };

    case "SAVE_GEOFENCE_SUCCESS":
      return {
        ...state,
        isSaving: false,
        geofences: [...state.geofences, action.payload],
        activeGeofence: null,
        saveSuccess: "Geofence saved successfully!",
      };

    case "SAVE_GEOFENCE_FAILURE":
      return { ...state, isSaving: false, saveError: action.payload };

    case "DELETE_GEOFENCE_START":
      return {
        ...state,
        isSaving: true,
        saveError: null,
      };

    case "DELETE_GEOFENCE_SUCCESS":
      return {
        ...state,
        isSaving: false,
        geofences: state.geofences.filter(
          (geofence) => geofence._id !== action.payload.geofenceId
        ),
        saveSuccess: action.payload.success,
      };

    case "DELETE_GEOFENCE_FAILURE":
      return {
        ...state,
        isSaving: false,
        saveError: action.payload,
      };
    case "CLEAR_GEOFENCE_SUCCESS":
      return { ...state, saveSuccess: null };
    case "CLEAR_GEOFENCE_FAILURE":
      return { ...state, saveError: null };

    case "OPEN_SIDE_BAR":
      return { ...state, isSideBarOpen: true };
    case "CLOSE_SIDE_BAR":
      return { ...state, isSideBarOpen: false };

    case "SET_SELECTED_GEOFENCE": {
      return { ...state, selectedGeofenceId: action.payload };
    }
    case "SET_EDITING_GEOFENCE": {
      return {
        ...state,
        editingGeofence: action.payload,
        selectedGeofenceId: null,
      };
    }
    case "CLEAR_EDITING_GEOFENCE": {
      return { ...state, editingGeofence: null, selectedGeofenceId: null };
    }

    case "ASSIGN_GEOFENCE_START":
      return { ...state, isSaving: true, saveError: null };

    case "ASSIGN_GEOFENCE_SUCCESS":
      return { ...state, isSaving: false, saveSuccess: action.payload };

    case "ASSIGN_GEOFENCE_FAILURE":
      return { ...state, isSaving: false, saveError: action.payload };

    case "UNASSIGN_GEOFENCE_START":
      return { ...state, isSaving: true, saveError: null };

    case "UNASSIGN_GEOFENCE_SUCCESS":
      return { ...state, isSaving: false, saveSuccess: action.payload };

    case "UNASSIGN_GEOFENCE_FAILURE":
      return { ...state, isSaving: false, saveError: action.payload };

    case "UPDATE_GEOFENCE_REQUEST":
      return {
        ...state,
        isSaving: true,
      };
    case "UPDATE_GEOFENCE_SUCCESS":
      return {
        ...state,
        isSaving: false,
        geofences: state.geofences.map((geofence) =>
          geofence._id === action.payload._id ? action.payload : geofence
        ),
        saveSuccess: "Geofence updated successfully!",
      };
    case "UPDATE_GEOFENCE_FAILURE":
      return {
        ...state,
        isSaving: false,
        saveError: action.payload,
      };

    default:
      return state;
  }
};

export default geofenceReducer;
